// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__14Sqf","footer":"ModalError_footer__2GNSh"};